module.exports = __webpack_public_path__ + "img/reference54.7a886e58.jpg";